var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vFlatPickr',{attrs:{"value":_vm.value,"config":_vm.config},on:{"on-change":_vm.changeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }